import type { InteractionEvent, Item, Session, User } from '@app/core';
import type { Table } from 'dexie';
import Dexie from 'dexie';

export class AppDatabase extends Dexie {
  items!: Table<Item, string>;
  sessions!: Table<Session, string>;
  interactions!: Table<InteractionEvent, string>;
  users!: Table<User, string>;

  constructor() {
    super('pribram-app');
    this.version(1).stores({
      items: 'id, status, createdAt',
      sessions: 'id, openedAt',
      interactions: 'id, itemId, sessionId, timestamp',
      users: 'id',
    });
  }
}

export const db = new AppDatabase();
